import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Lock, Mail, ArrowRight } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const r = await login(email, password);
    setLoading(false);
    if (r.ok) {
      const target = r.user.role === "admin" ? "/admin" : "/dashboard";
      nav(loc.state?.from || target, { replace: true });
    } else setError(r.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-24">
      <div className="card p-8 w-full max-w-md glow-border" data-testid="login-card">
        <div className="eyebrow">Welcome back</div>
        <h1 className="text-3xl font-bold text-white mt-1">Sign in</h1>
        <p className="text-[#94A3B8] text-sm mt-1">Access your ZeroLabs Digitals dashboard.</p>

        <form onSubmit={submit} className="mt-6 space-y-4">
          <div className="relative">
            <Mail size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#64748B]"/>
            <input data-testid="login-email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} className="input-field !pl-9" placeholder="you@company.com"/>
          </div>
          <div className="relative">
            <Lock size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#64748B]"/>
            <input data-testid="login-password" type="password" required value={password} onChange={(e)=>setPassword(e.target.value)} className="input-field !pl-9" placeholder="Password"/>
          </div>
          {error && <div data-testid="login-error" className="text-sm text-red-300 bg-red-500/10 border border-red-500/30 rounded-lg p-3">{error}</div>}
          <button data-testid="login-submit" disabled={loading} className="btn-primary w-full justify-center disabled:opacity-60">
            {loading ? "Signing in…" : (<>Sign in <ArrowRight size={16}/></>)}
          </button>
          <div className="text-center">
            <Link data-testid="login-forgot-password" to="/contact?subject=password-reset" className="text-sm text-[#22D3EE] hover:underline">
              Forgot password?
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
